import { motion } from "framer-motion";
import { Check, X } from "lucide-react";
import { WHY_CHOOSE, COMPARISON } from "@/config";
import { SectionHeading } from "@/components/Section";
import { Reveal, stagger, fadeUp } from "@/components/Reveal";

export default function WhyChooseUs() {
  return (
    <section data-testid="why-choose-us" className="py-24 md:py-32 bg-white border-y border-forest/10">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <SectionHeading
          chapter="10 / Why Choose Us"
          overline="The Difference"
          title={<>Why restaurants choose Brampton Cash &amp; Carry</>}
          className="mb-14"
        />

        {/* Comparison */}
        <div className="grid md:grid-cols-2 gap-6 mb-16">
          <Reveal className="rounded-3xl border border-forest/15 bg-muted/50 p-7">
            <h3 className="font-display text-xl text-forest/60 mb-5">Traditional Ordering</h3>
            <ul className="space-y-3.5">
              {COMPARISON.traditional.map((t) => (
                <li key={t} className="flex items-start gap-3 text-sm text-forest/60">
                  <X className="h-4 w-4 mt-0.5 shrink-0 text-forest/40" /> {t}
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.1} className="rounded-3xl border border-forest bg-forest text-cream p-7 shadow-hard-lg">
            <h3 className="font-display text-xl text-butter mb-5">Brampton Cash &amp; Carry</h3>
            <ul className="space-y-3.5">
              {COMPARISON.ecc.map((t) => (
                <li key={t} className="flex items-start gap-3 text-sm text-cream/90">
                  <span className="grid place-items-center h-5 w-5 rounded-full bg-butter-deep text-forest shrink-0 mt-0.5"><Check className="h-3 w-3" /></span> {t}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>

        {/* Reasons grid */}
        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true }} className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-3">
          {WHY_CHOOSE.map((w) => (
            <motion.div key={w} variants={fadeUp} className="flex items-center gap-3 border-b border-forest/10 py-3">
              <span className="grid place-items-center h-6 w-6 rounded-full bg-sage text-forest shrink-0"><Check className="h-3.5 w-3.5" /></span>
              <span className="text-sm font-medium text-forest">{w}</span>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
